import { Tag } from "antd";
import "./ppr-chip-status.less";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faOctagonExclamation,
  faCircleCheck,
  faWarning,
} from "@awesome.me/kit-b311a11e92/icons/classic/solid";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export type ChipStatus = "passed" | "failed" | "analyzing" | "not-started";
export type CustomStatus = "meet-requirement" | "not-meet-requirement";

interface PprChipStatusProps {
  status: ChipStatus | CustomStatus;
}

const mapStatus = (
  status: ChipStatus | CustomStatus,
): { i18nLabel: string; classname?: string; icon?: IconDefinition } => {
  switch (status) {
    case "not-started":
      return {
        i18nLabel: "CHIP_STATUS.NOT_STARTED",
      };
    case "analyzing":
      return {
        i18nLabel: "CHIP_STATUS.ANALYZING",
        classname: "analyzing",
        icon: faWarning,
      };
    case "passed":
      return {
        i18nLabel: "CHIP_STATUS.PASSED",
        classname: "passed",
        icon: faCircleCheck,
      };
    case "failed":
      return {
        i18nLabel: "CHIP_STATUS.FAILED",
        classname: "failed",
        icon: faOctagonExclamation,
      };
    case "meet-requirement":
      return {
        i18nLabel: "CHIP_STATUS.MEET_REQUIREMENT",
        classname: "passed",
        icon: faCircleCheck,
      };
    case "not-meet-requirement":
      return {
        i18nLabel: "CHIP_STATUS.NOT_MEET_REQUIREMENT",
        classname: "failed",
        icon: faOctagonExclamation,
      };
    default:
      return {
        i18nLabel: "",
      };
  }
};

function PprChipStatus({ status }: PprChipStatusProps) {
  const { i18nLabel, classname, icon } = mapStatus(status);
  const { t } = useTranslation();

  return (
    <Tag tabIndex={-1} className={`ppr-chip-status ${classname ?? ""}`}>
      {!!icon && <FontAwesomeIcon className={`icon`} icon={icon} />}
      {t(i18nLabel)}
    </Tag>
  );
}

export default PprChipStatus;
